import React from 'react';
import PropTypes from 'prop-types';

import { useAppContext } from '../../common/contexts/AppContext';
import { POPUP_SETTINGS } from '../../constants/popups';
import assessmentTypeStorage from '../../common/storage/assessmentTypeStorage';

const StaffLogoutButton = ({ logoutTrigger }) => {
    const { staff } = useAppContext();
    const handleLogout = () => {
        localStorage.removeItem(POPUP_SETTINGS);
        sessionStorage.removeItem(staff.id);
        assessmentTypeStorage.clear();
        logoutTrigger();
    };
    // TODO: not using Button component because there is a problem with prefixing styles while deploying
    return (
        <div className='dashboard-staff-wrapper'>
            <div className='dashboard-staff-item'>
                <div className='dashboard-staff-text'>{`${staff.firstName} ${staff.lastName}`}</div>
            </div>
            <div className='dashboard-separator' />
            <button type="button" onClick={handleLogout} className='dashboard-logout-button'>
                <div className='dashboard-staff-item'>
                    <div className='dashboard-staff-text'>Log Out</div>
                </div>
            </button>
        </div>
    );
};

StaffLogoutButton.defaultProps = {
    logoutTrigger: () => {},
};

StaffLogoutButton.propTypes = {
    logoutTrigger: PropTypes.func,
};

export default StaffLogoutButton;
